module.exports = __webpack_public_path__ + "i18n/it.cfa22bc303136a3715c4006fe5855574.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/it.json
// module id = 1286
// module chunks = 60